export const getTotalEnrollmentsData = getters => {
  return getters.totalEnrollmentsData
}
